import { IApplicationState } from '../../types/redux';

export const selectFilters = (state: IApplicationState) => state.filters;
